/**
 * The header's one menu (sections/header.liquid, <header-more>).
 *
 * The <details> inside already opens and closes on its own with no script;
 * this adds what a menu needs beyond that:
 * - closing on a click outside it and on Escape (focus goes back to the
 *   button that opened it);
 * - closing after a choice, so a link or the theme switch does not leave
 *   the panel hanging open;
 * - "Search": the search overlay's own trigger is hidden on desktop, so this
 *   row closes the menu and opens the overlay by clicking that trigger,
 *   which leaves <search-overlay> in charge of everything it already does.
 */
(function () {
  if (customElements.get('header-more')) return;

  class HeaderMore extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.summary = this.details.querySelector('summary');
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);

      var search = this.querySelector('[data-more-search]');
      if (search) {
        search.addEventListener('click', () => {
          this.close(false);
          var trigger = document.querySelector('.header__search-details > summary');
          if (trigger) trigger.click();
        });
      }

      // The theme switch stays in the menu for a moment so the change is
      // seen, then the menu closes; links navigate away on their own.
      var toggle = this.querySelector('[data-theme-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => {
          window.setTimeout(() => this.close(false), 350);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
    }

    close(returnFocus) {
      if (!this.details.open) return;
      this.details.open = false;
      if (returnFocus && this.summary) this.summary.focus();
    }

    onDocClick(event) {
      if (this.details.open && !this.contains(event.target)) this.close(false);
    }

    onKey(event) {
      if (event.key === 'Escape') this.close(true);
    }
  }

  customElements.define('header-more', HeaderMore);
})();
